window.reportSplit = (experiment, goal = null) => {
  var data = {
    exp: experiment,
  };
  if(goal) data.goal = goal;
  $.ajax({
    type: "POST",
    url: "/split_metrics",
    data: data,
  })
}
